import { useEffect } from 'react'
import { useTheme } from './ThemeProvider'

const ThemeMetaTags = () => {
  const { resolvedTheme } = useTheme()

  useEffect(() => {
    // Get the theme-color meta tag
    const metaThemeColor = document.querySelector('meta[name="theme-color"]')
    
    if (metaThemeColor) {
      // Update based on current theme
      if (resolvedTheme === 'dark') {
        metaThemeColor.setAttribute('content', '#020617') // Dark mode background color
      } else {
        metaThemeColor.setAttribute('content', '#ffffff') // Light mode background color
      }
    }
  }, [resolvedTheme])

  // This component doesn't render anything visible
  return null
}

export default ThemeMetaTags 